<template>
<div>
     <b-form-group v-if="!auftrag.firma" label-cols="12" class="mb-0" :label-class="labelClass"
      id="input-group-5"
      label="Firma Formular:"
      label-for="input-5">
      <b-form-input id="input-5"  v-model="auftrag.firmaFormular" type="text" placeholder="Name eingeben..."/>
     </b-form-group>

    <b-form-group label-cols="12"  class="mb-0"
          id="input-group-1"
          label="Aus Adressbuch auswählen:"
          :label-class="labelClass"
          label-for="input-1">
     <b-form-select
          id="input-1"
          ref="selectkundefield"
          @change="checkAddress($event)"
          v-model="auftrag.firmaId">
          <option v-for="(sp, idx) in kunden" v-bind:key="idx" :data-plz="sp.plz" :data-ort="sp.ort" :data-strasse="sp.strasse" :value="sp.id">{{sp.name}}</option>
      </b-form-select>
      </b-form-group>

    <div class="mb-0">
     <b-row  no-gutters>
     <b-col cols="12" md="4">
    <b-form-group label-cols="12"
      id="input-group-kunde"
      label="Kunde:"
      label-for="input-kunde">
    <b-form-input
      id="input-kunde"
      v-model="auftrag.kundeFormular"
      type="text"
      placeholder="Kunde eingeben...">
    </b-form-input>
  </b-form-group>
  </b-col>
   <b-col cols="12" md="4">
      <b-form-group label-cols="12"
          id="input-group-8"
          label="Sendung:"
        class="pl-2"
          label-for="input-8">
          <b-form-input id="input-8"  v-model="auftrag.sendung" type="text" placeholder="Sendung eingeben..."/>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="4">
      <b-form-group label-cols="12"
        id="input-group-8"
        label="Thema:"
        class="pl-2"
        label-for="input-9">
          <b-form-input id="input-9" v-model="auftrag.thema" type="text" placeholder="Thema eingeben..."/>
    </b-form-group>
  </b-col>
  </b-row>
  </div>
   <div class="mb-2">
   <b-row  no-gutters>
     <b-col cols="12" md="6">
    </b-col>
    <b-col cols="12" md="6">
  </b-col>
  </b-row>

   </div>

   <div class="mb-2">

 <b-row>
 <b-col>
     <b-form-group label-cols="12" class="mb-0" :label-class="labelClass"
      id="input-group-5"
      label="Datum:"
      label-for="input-5">
      <b-form-input id="input-5" maxlength=64 v-model="auftrag.datum" type="text" placeholder="kein Datum..."/>
  </b-form-group>
</b-col>
<b-col>
  <b-form-group label-cols="12"
      id="input-group-10"
      label="Format:"
      label-for="input-10">
       <b-form-select
          id="input-10"
          v-model="auftrag.formatId"
          required>
          <option v-for="sp in formate" v-bind:key="sp.id" :value="sp.id">{{sp.name}}</option>
        </b-form-select>
  </b-form-group>
</b-col>
</b-row>
      <b-form-group label-cols="12"
          id="input-group-8"
          label="Anzahl Tage:"
          label-for="input-8">
       <b-input-group>
          <b-form-input id="input-8" maxlength="32" v-model="auftrag.tageFormular" type="text" placeholder="Dauer eingeben..."/>
      <template #append>
      <b-input-group-text v-if="!auftrag.tage"><strong class="text-danger" v-b-tooltip.hover title="Kein Wert erkannt">!</strong></b-input-group-text>
        <b-input-group-text v-if="auftrag.tage"><strong class="text-success" v-b-tooltip.hover :title="erkannt(auftrag.tage)"><i class="bi bi-check"></i></strong></b-input-group-text>
      </template>
       </b-input-group>
      </b-form-group>

   <b-form-group label-cols="12"
      id="input-group-11"
      label="Schnittsoftware:"
      label-for="input-11">
       <b-form-select
          id="input-11"
          v-model="auftrag.skillId"
          required>
          <option v-for="(sp,id) in skills" v-bind:key="id" :value="id">{{sp.name}}</option>
        </b-form-select>
  </b-form-group>
  <b-form-group label-cols="12"
        id="input-group-8"
        label="Gage (8h):"
        label-for="input-9">
       <b-input-group>
           <b-form-input id="input-9" maxlength="32" v-model="auftrag.gageFormular" type="text" placeholder="Bitte den Gagenvorschlag eingeben..."/>
        <template #append>
        <b-input-group-text v-if="!auftrag.gage"><strong class="text-danger" v-b-tooltip.hover title="Kein Wert erkannt">!</strong></b-input-group-text>
        <b-input-group-text v-if="auftrag.gage"><strong class="text-success" v-b-tooltip.hover :title="erkannt(auftrag.gage)"><i class="bi bi-check"></i></strong></b-input-group-text>
        </template>
       </b-input-group>
    </b-form-group>

     <b-form-group label-cols="12"
        id="input-group-tkm"
        label="Technikmiete:"
        label-for="input-tkm">
       <b-input-group append="€">
           <b-form-input  id="input-tkm" v-model="auftrag.technikMiete" type="text" placeholder="Bitte Technikmiete eingeben..."/>
       </b-input-group>
    </b-form-group>

  <b-form-group label-cols="12"
      id="input-group-15"
      label="Infos vom Kunden:"
      label-for="input-15">
     <b-form-textarea ref="info" @keydown="myPrevent($event, 'info')"  rows="2" id="input-15" v-model="auftrag.information" placeholder="keine Informationen..."></b-form-textarea>
  </b-form-group>

    <b-form-group
       label-cols="12"
      id="input-group-info-dispo"
      label="Infos vom Disponenten an Cutter*innen:"
      label-for="input-info-dispo">
     <b-form-textarea ref="infoDispo" @keydown="myPrevent($event, 'infoDispo')"  rows="2" id="input-info-dispo" :disabled="!editMode"  :plaintext="!editMode"  v-model="auftrag.informationDispo" placeholder="keine Informationen...."></b-form-textarea>

  </b-form-group>

    <b-form-group
       label-cols="12"
      id="input-group-info-dispo"
      label="Infos vom Disponenten an Kunde:"
      label-for="input-info-dispo">
     <b-form-textarea ref="infoDispoKunde" @keydown="myPrevent($event, 'infoDispoKunde')"  rows="2" id="input-info-dispokunde" :disabled="!editMode"  :plaintext="!editMode"  v-model="auftrag.informationDisponentKunde" placeholder="keine Informationen...."></b-form-textarea>
  </b-form-group>

 <h5 class="mt-3">Arbeitsort</h5>
   <div>
   <b-row>
   <b-col>
  <b-form-group
      label-cols="12"
      id="input-schnittplatz"
      label="Schnittplatz"
      label-for="input-2" >
     <b-form-select
      id="input-schnittplatz"
      @change="onUpdateSchnittplatz()"
      v-model="auftrag.schnittplatzId">
      required>
      <option v-for="(value, idx) in schnittplaetze" :key="idx" :value="value.id">{{value.name}}</option>
  </b-form-select>
   </b-form-group>
   </b-col>
   <b-col>
  <b-form-group
      label-cols="12"
      id="input-standort"
      label="Standort"
      label-for="input-2" >
      <b-form-input id="input-3" maxlength="6" v-model="auftrag.standortFormular" type="text" placeholder="Standort"/>
   </b-form-group>
   </b-col>
   </b-row>
<b-row v-if="auftrag.schnittplatzId && !findSchnittplatz(auftrag.schnittplatzId).useCutterAddress">
 <b-col>
  <b-form-group
      label-cols="12"
      id="input-group-2"
      label="Strasse"
      label-for="input-2" >
       <b-form-input id="input-2" maxlength="64" v-model="auftrag.firmaStrasse" type="text" placeholder="Strasse eingeben..."/>
  </b-form-group>
  </b-col>
 <b-col lg="2">
  <b-form-group
      label-cols="12"
      id="input-group-3"
      label="PLZ:"
      label-for="input-3">
      <b-form-input id="input-3" maxlength="6" v-model="auftrag.firmaPlz" type="text" placeholder="PLZ eingeben..."/>
  </b-form-group>
  </b-col>
 <b-col>
  <b-form-group label-cols="12"
      id="input-group-4"
      label="Ort:"
      label-for="input-4">
    <b-form-input
      id="input-4"
      v-model="auftrag.firmaOrt"
      maxlength="64"
      type="text"
      placeholder="Ort eingeben...">
    </b-form-input>
  </b-form-group>
  </b-col>
  </b-row>
</div>
</div>

<div class="mb-2">
 <h5 class="mb-1">Abrechnung</h5>
  <b-form-select
      id="input-abrechnung"
      v-model="auftrag.abrechnungsArt"
      required>
      <option v-for="(value, idx) in abrechnungOptions" :key="idx" :value="idx">{{value.description}}</option>
  </b-form-select>
</div>

<div class="mb-2">
 <h5 class="mb-1">Vermittlungsart</h5>
  <b-form-select
      id="input-va"
      v-model="auftrag.vermittlungsArt"
      required>
      <option v-for="(value, vaidx) in vermittlungsArten" :key="vaidx" :value="value.name">{{value.text}}</option>
  </b-form-select>
</div>

<div class="mb-2">
 <h5 class="mb-1">Vermittlungsprovision</h5>
  <b-form-select
      id="input-vp"
      v-model="auftrag.vermittlungsProvision"
      required>
      <option v-for="(value, vpidx) in vermittlungsProvisionen" :key="vpidx" :value="value.percent">{{value.percent|number}}%</option>
  </b-form-select>
</div>

<div class="mb-2">
 <h5 class="mb-1">Kontakt Kunde</h5>
 <b-row>
 <b-col>
  <b-form-group
      label-cols="12"
      id="input-group-2"
      label="Name:"
      label-for="input-2" >
      <b-form-input id="input-2" v-model="auftrag.name" type="text" placeholder="Ihren Namen eingeben..." required/>
  </b-form-group>
  </b-col>
 <b-col>
  <b-form-group
      label-cols="12"
      id="input-group-3"
      label="Telefon:"
      label-for="input-3">
      <b-form-input id="input-3" maxlength="32" v-model="auftrag.telefon" type="text" placeholder="Ihre Telefonnummer für Rückfragen eingeben..."/>
  </b-form-group>
  </b-col>
 <b-col>
  <b-form-group label-cols="12"
      id="input-group-4"
      label="E-Mail:"
      label-for="input-4">
    <b-form-input
      id="input-1"
      v-model="auftrag.email"
      type="email"
      maxlength="100"
      placeholder="E-Mail Adresse eingeben..."
      required >
    </b-form-input>
  </b-form-group>
  </b-col>
  </b-row>
</div>

<div class="mb-2">
 <h5 class="mb-1">Disposition</h5>
  <b-form-select
      id="input-disponent"
      v-model="auftrag.disponentId">
      <option v-for="(sp, idx) in disponenten" v-bind:key="idx" :value="sp.id">{{sp.name}}</option>
  </b-form-select>
</div>
<div class="mb-2">
 <h5 class="mb-0">Editoren</h5>
  <CutterAngebotTable ref="CutterAngebotTable" :angebote="auftrag.angebote" :selectedCutters="selectedCutters" :einzuladendeCutter="einzuladendeCutter" :cutters="cutters" :auftrag="auftrag"/>
</div>

<div class="mb-2">
    <b-form-group v-if="auftrag.__myAngebot && !auftrag.cutterId && auftrag.__myAngebot.auftragAngebotStatus=='NeueAnfrage'"
      label-cols="12"
      id="input-group-info-message"
      label="Nachricht:"
      label-for="input-info-message">
     <b-form-textarea ref="ddMessage" @keydown="myPrevent($event, 'ddMessage')" rows="2" id="input-info-message" v-model="aaMessage" placeholder="Nachricht an Disposition..."></b-form-textarea>
  </b-form-group>
 </div>

<div class="mb-2" v-if="auftrag.disponentId == user.id && auftrag.cutterId">
    <b-form-group
      label-cols="12"
      id="input-group-bewertung"
      label="Bewertung:"
      label-for="input-info-bewertung">
     <b-form-textarea ref="bewertung" @keydown="myPrevent($event, 'bewertung')" rows="2" id="input-info-bewertung" v-model="auftrag.editorbewertung" placeholder="Bewertung..."></b-form-textarea>
  </b-form-group>
 </div>

 <div class="mb-2" v-if="editMode && auftrag.fileMap && Object.keys(auftrag.fileMap).length>0">
    <b-form-group
      label-cols="12"
      label="Rechnungen">
      <div v-for="(file, key) in auftrag.fileMap" :key="key">
      <span v-if="showFunctions()">{{file.created|formatDate}}: </span> {{translate(key)}}: <b-link :href="fileLink(auftrag.id, key)">{{file.filename}}</b-link>
      </div>
  </b-form-group>
 </div>

 <div class="mb-2" v-if="editMode && auftrag.sevdeskId">
  Die Rechnung wurde zu Sevdesk übertragen.
 </div>

</div>
</template>
<script>
import utils from '@/utilities'
import afunc from '@/functions'
import CutterAngebotTable from '@/components/partials/CutterAngebotTable'
import benutzerApi from '@/api/benutzer'

export default {
  props: ['user', 'auftrag', 'disponenten', 'cutters', 'kunden', 'selectedCutters', 'einzuladendeCutter', 'editMode'],
  name: 'AntragDisponent',
  components: {CutterAngebotTable},
  methods: {
    showFunctions () {
      return afunc.showInternalFunctions(this.user)
    },
    checkAddress (value) {
      let opt = this.$refs['selectkundefield'].$el.options[this.$refs['selectkundefield'].$el.selectedIndex]
      // wenn Kunde eingestellt ist, kopiere die Adresse
      if (this.auftrag.schnittplatzId === 1) {
        this.auftrag.firmaPlz = opt.attributes['data-plz'].value
        this.auftrag.firmaStrasse = opt.attributes['data-strasse'].value
        this.auftrag.firmaOrt = opt.attributes['data-ort'].value
      }
    },
    myPrevent (event, field) {
      if (event.key === 'Enter') {
        if (this.$refs[field]) {
          afunc.insertAtCaret(event.target, '\n')
        }
        event.preventDefault()
        event.stopPropagation()
      }
    },
    findSchnittplatz (schnittplatzId) {
      for (let i = 0; i < this.schnittplaetze.length; i++) {
        if (this.schnittplaetze[i].id === schnittplatzId) {
          return this.schnittplaetze[i]
        }
      }
      return {useAddress: false, useCutterAddress: false, name: ''}
    },
    async onUpdateSchnittplatz () {
      let sp = this.findSchnittplatz(this.auftrag.schnittplatzId * 1)
      if (sp.useAddress) {
        this.auftrag.firmaStrasse = sp.strasse
        this.auftrag.firmaPlz = sp.plz
        this.auftrag.firmaOrt = sp.ort
      }
      if (sp.useCutterAddress && this.auftrag.cutterId) {
        let cutter = await benutzerApi.get(this.auftrag.cutterId)
        if (cutter) {
          this.auftrag.firmaStrasse = cutter.strasse
          this.auftrag.firmaPlz = cutter.plz
          this.auftrag.firmaOrt = cutter.ort
        }
      }
      if (sp.name === 'Kunde' && this.auftrag.firmaId) {
        let kunde = await benutzerApi.get(this.auftrag.firmaId)
        if (kunde) {
          this.auftrag.firmaStrasse = kunde.strasse
          this.auftrag.firmaPlz = kunde.plz
          this.auftrag.firmaOrt = kunde.ort
        }
      }
    },
    translate (key) {
      if (key === 'AuftragRechnung') {
        return 'Rechnung an Editor*in / Firma'
      }
      if (key.startsWith('CutterRechnung')) {
        return 'Rechnung von Editor*in'
      }
      return key
    },
    fileLink (id, key) {
      return '/api/ws/getfile/' + id + '/' + key + '/' + this.$store.state.auth.token
    },
    csvLink (id) {
      return '/api/ws/getcsv/' + id + '/' + this.$store.state.auth.token
    },
    hasRole (role) {
      return this.hasRoles([role])
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    },
    erkannt (wert) {
      return 'Erkannt als ' + wert
    }
  },
  computed: {
    labelClass: function () {
      return this.editMode ? '' : 'd-none'
    },
    sendungThema: function () {
      return (this.auftrag.sendung || 'n.v.') + ' - ' + (this.auftrag.thema || 'n.v.')
    }
  },
  data () {
    return {
      skills: this.$store.state.auth.baseData.skills,
      schnittplaetze: this.$store.state.auth.baseData.schnittplaetze,
      formate: this.$store.state.auth.baseData.allFormats,
      abrechnungOptions: this.$store.state.auth.baseData.abrechnungsArten,
      vermittlungsProvisionen: this.$store.state.auth.baseData.vermittlungsProvisionen,
      vermittlungsArten: this.$store.state.auth.baseData.vermittlungsArten
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/AuftragDisponent.vue